import React from 'react';
import { CTAButton } from './CTAButton';
import { CHECKOUT_URL, OFFER_ANCHOR, PRODUCT_IMG } from './constants';
export function FinalCTA() {
  return <section className="bg-brand-carbon px-4 py-5 text-white" data-id="element-51" data-mp="3ue881g6d6wqu">
      <div className="mx-auto max-w-2xl text-center" data-id="element-52" data-mp="c7tw1mrnowv3">
        <p className="font-cond text-[12px] font-bold uppercase tracking-[0.2em] text-brand-yellow sm:text-sm" data-id="element-53" data-mp="c4fwemadn1rc">
          One Last Question
        </p>
        <h2 className="mb-1 font-display text-[20px] leading-tight text-white sm:text-3xl" data-id="element-54" data-mp="m3nipyz3a6ql">
          When another maintenance problem appears… do you immediately know what needs attention
          first?
        </h2>
        <p className="mb-2.5 text-[13px] font-medium leading-snug text-brand-line sm:text-base" data-id="element-55" data-mp="vtymnlirwfxh">
          Stop rebuilding your maintenance process from scratch. Open the system. Find the task.
          Follow the maintenance workflow.{' '}
          <span className="font-bold text-white" data-id="element-56" data-mp="zwmxtzuylyxm">Inspect. Prevent. Maintain.</span>
        </p>

        <a href={OFFER_ANCHOR} className="mb-2.5 block cursor-pointer" aria-label="Go to the offer" data-id="element-57" data-mp="2c4wmkk3t04fa">
          <img src={PRODUCT_IMG} alt="Maintenance Ready 6-in-1 system box set" className="mx-auto w-full max-w-[200px] object-contain drop-shadow-2xl transition-transform duration-150 ease-out hover:scale-[1.02]" data-id="element-58" data-mp="2h3hmsjj22o3q" />
        </a>

        <p className="font-display text-[19px] leading-tight text-brand-yellow sm:text-2xl" data-id="element-59" data-mp="2r2yroyqhgxyn">
          🔧 MAINTENANCE READY™
        </p>
        <p className="font-cond text-[13px] font-semibold uppercase leading-snug text-brand-line sm:text-base" data-id="element-60" data-mp="2v1g15oxdmkj8">
          The Complete Ready-To-Use Maintenance System for Maintenance Professionals
        </p>
        <p className="mb-2.5 font-cond text-[12px] font-bold uppercase tracking-wide text-white sm:text-sm" data-id="element-61" data-mp="34vof97lnuaxv">
          Prevent • Inspect • Troubleshoot • Execute • Record • Control
        </p>

        <p className="mb-1.5 font-cond text-[14px] font-bold uppercase tracking-wide text-brand-yellow sm:text-lg" data-id="element-62" data-mp="3epf2k961wfbz">
          🔥 Get the complete system today
        </p>
        <CTAButton href={CHECKOUT_URL} className="mx-auto max-w-md" data-id="element-63" data-mp="1jp4vxveuv9pz">
          🔧 GET MAINTENANCE READY™
        </CTAButton>
        <p className="mt-1.5 text-[12px] font-semibold text-brand-line" data-id="element-64" data-mp="1en5r0h3gw4qx">
          Immediate Access • Digital Delivery · 🛡️ 7-Day Money-Back Guarantee
        </p>
      </div>
    </section>;
}